import { Box, DateRange, Flex, Select } from "@nulogy/components";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import flatMap from "lodash/flatMap";
import min from "lodash/min";
import React from "react";
import EngagedSites from "./EngagedSites";

export default function AdminDashboardView({
  charts,
  startDate,
  endDate,
  handleRangeChange,
  handleSiteChange,
  companies,
}) {
  const options = siteOptionsForSelect(companies);

  return (
    <PageWithBreadcrumbs title="Administrator dashboard">
      <Flex alignItems="center" justifyContent="space-between">
        <Box paddingRight="x4" width="650px">
          <DateRange
            defaultEndDate={endDate}
            defaultStartDate={startDate}
            labelProps={{ labelText: "" }}
            onRangeChange={handleRangeChange}
          />
        </Box>
        <Select
          defaultValue={null}
          maxHeight="250"
          onChange={handleSiteChange}
          options={options}
          placeholder="Select site..."
        />
      </Flex>
      <Flex flexDirection="row" flexWrap="wrap" justifyContent="flex-start">
        {charts.map(({ ChartComponent, data, label, keys }) => (
          <Box key={label} width={1 / min([1, charts.length])}>
            <Box boxShadow="large" margin="x3">
              <ChartComponent data={data} keys={keys} title={label} />
            </Box>
          </Box>
        ))}
        <EngagedSites endDate={endDate} startDate={startDate} />
      </Flex>
    </PageWithBreadcrumbs>
  );
}

function siteOptionsForSelect(companiesWithSites) {
  const allOption = [{ label: "All sites", value: null }];
  const companyOptions = flatMap(companiesWithSites, ({ name: companyName, sites }) =>
    sites.map(({ name: siteName, id }) => ({ label: `${companyName} - ${siteName}`, value: id })),
  );

  return [...allOption, ...companyOptions];
}
